export var SaasCaptureOutcome;
(function (SaasCaptureOutcome) {
    SaasCaptureOutcome["SAAS_CAPTURE_OUTCOME_DATA"] = "DATA";
    SaasCaptureOutcome["SAAS_CAPTURE_OUTCOME_EMPTY"] = "EMPTY";
    SaasCaptureOutcome["SAAS_CAPTURE_OUTCOME_SKIPPED"] = "SKIPPED";
    SaasCaptureOutcome["SAAS_CAPTURE_OUTCOME_NOT_CAPTURED"] = "NOT_CAPTURED";
})(SaasCaptureOutcome || (SaasCaptureOutcome = {}));
